import { PlanId } from "components/common/boundary/PlanId";
import { Period } from "hooks/periodIndex";
import React from "react";
import {
  planMixTableEditsSlice,
  selectCollapsedMixIds,
} from "src/store/slices/planMixesTableEditSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";

export interface MixCollapse {
  collapsedMixIds: ReadonlySet<number>;
  collapsedMixIdArray: number[];
  onToggleCollapse: (mixId: number) => void;
}

export const useMixCollapse = (planId: PlanId, period: Period): MixCollapse => {
  const dispatch = useAppDispatch();
  const collapsedMixIdArray = useAppSelector((state) =>
    selectCollapsedMixIds(state, planId, period)
  );

  const collapsedMixIds = React.useMemo(
    () => new Set(collapsedMixIdArray),
    [collapsedMixIdArray]
  );

  const onToggleCollapse = React.useCallback(
    (mixId: number) => {
      dispatch(
        planMixTableEditsSlice.actions.toggleCollapsedMix([
          planId,
          period,
          mixId,
        ])
      );
    },
    [dispatch, planId, period]
  );

  return React.useMemo(
    () => ({ collapsedMixIds, collapsedMixIdArray, onToggleCollapse }),
    [collapsedMixIds, collapsedMixIdArray, onToggleCollapse]
  );
};
